<template>
  <div>
    <base-confirm
      :visible="visible"
      @close="$emit('close')"
      @confirmed="onConfirmed"
      @opened="onOpened"
      size="max-w-lg"
      message="Masukkan nama petugas gudang yang menyiapkan"
      type="success"
      icon-type="badge"
      title="Persiapan"
      confirm-text="Simpan"
      cancel-text="Tutup"
    >
      <template #content>
        <base-input inset type="text" label="Nama Petugas" placeholder="Masukkan nama petugas" v-model="name" />
      </template>
    </base-confirm>
    <loading v-if="withLoading && loading" />
  </div>
</template>

<script>
import BaseConfirm from '@/components/base/BaseConfirm.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';

export default {
  components: { BaseConfirm },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    orderId: String,
    withLoading: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close', 'confirmed', 'submit'],
  data() {
    return {
      loading: false,
      name: null
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onConfirmed() {
      this.loading = true;

      this.$emit('submit')

      const [, err] = await this.request(
        `/api/v1/orders/${this.orderId}`,
        {
          method: 'patch',
          data: {
            data: {
              type: 'orders',
              id: this.orderId,
              attributes: {
                prepared_by_name: this.name
              }
            }
          }
        }
      );

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      } else {
        this.$emit('confirmed');
      }

      this.loading = false;
    },
    onOpened() {
      this.name = null
    }
  },
};
</script>
